import { createListenerMiddleware, TypedStartListening } from '@reduxjs/toolkit';

import { selectIndustry } from '../selectors';
import { selectCoverStart } from '../selectors/selectCoverOptions';
import { refDataApi } from '../services/refData';
import type { AppDispatch, RootState } from '../store';
import { utcDateFormatter } from '../utils/dateFormatter';

export const listenerMiddleware = createListenerMiddleware();

type AppStartListening = TypedStartListening<RootState, AppDispatch>;

const startAppListening = listenerMiddleware.startListening as AppStartListening;

/* Ensure dynamic covers are prefetched if industry or coverstart changes */
startAppListening({
  predicate: (action, currentState, previousState) => {
    const coverStart = selectCoverStart(currentState);
    const industry = selectIndustry(currentState);
    return (
      !!coverStart &&
      !!industry &&
      (utcDateFormatter(coverStart) !== utcDateFormatter(selectCoverStart(previousState) ?? '') ||
        industry !== selectIndustry(previousState))
    );
  },
  effect: async (action, listenerApi) => {
    listenerApi.dispatch(
      refDataApi.util.prefetch(
        'getDynamicCovers',
        {
          industryCode: selectIndustry(listenerApi.getState())!.industryCode,
          effectiveDate: utcDateFormatter(selectCoverStart(listenerApi.getState())!),
        },
        {}
      )
    );
  },
});
